const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecycleIndustry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144.15 155.96",
    style: {
      enableBackground: "new 0 0 144.15 155.96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 121.47,149.96 138.15,149.96 138.15,75.51 103.6,100.62 103.6,75.51 67.61,100.62 67.61,75.52 33.06,100.63 33.06,38.76 6,38.76 6,149.96 85.21,149.96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M54.47,131.83h-9.71c-1.2,0-2.17-0.97-2.17-2.17v-13.22c0-1.2,0.97-2.17,2.17-2.17h9.71 c1.2,0,2.17,0.97,2.17,2.17v13.22C56.64,130.86,55.67,131.83,54.47,131.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M88.22,131.83h-9.71c-1.2,0-2.17-0.97-2.17-2.17v-13.22c0-1.2,0.97-2.17,2.17-2.17h9.71 c1.2,0,2.17,0.97,2.17,2.17v13.22C90.39,130.86,89.41,131.83,88.22,131.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M121.96,131.83h-9.71c-1.2,0-2.17-0.97-2.17-2.17v-13.22c0-1.2,0.97-2.17,2.17-2.17h9.71 c1.2,0,2.17,0.97,2.17,2.17v13.22C124.13,130.86,123.16,131.83,121.96,131.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 12,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M19.53,15.62 C32.26,8.29,40.64,4.73,51.36,6.41s19.77,6.49,26.8,5.44c7.04-1.05,11.73-1.88,14.07-3.56"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleIndustry);
export default __webpack_public_path__ + "static/media/recycle-industry.c555c885cfd38b25c80297eceeb6cb9a.svg";
export { ForwardRef as ReactComponent };